(function() {
  if (window.CartDiscounts) return;
  const STOREFRONT_TOKEN = '6d6e1fa30a989296bd8b52baa9c7a55c';
  const SHOP_DOMAIN = 'icedstuff.myshopify.com';
  
  // STAN - ulepszona obsługa
  let isProcessing = false;
  let pendingQuantityUpdates = new Map();
  let qtyUpdateTimeouts = new Map();
  // Ilości, których zapis JEST W LOCIE. Wpis z pendingQuantityUpdates znika w chwili
  // wysyłki, a szuflada bywa w tym czasie przerysowana — bez tej mapy kolejny klik
  // liczyłby od input.value cofniętego do stanu serwera i inkrementacja przepadała.
  let inFlightQtyUpdates = new Map();
  const pendingOperations = new Set();
  const trackOperation = promise => {
    pendingOperations.add(promise);
    promise.then(() => pendingOperations.delete(promise), () => pendingOperations.delete(promise));
    return promise;
  };

  const $ = (sel) => document.querySelector(sel);
  const $$ = (sel) => document.querySelectorAll(sel);

  const formatMoney = (amount, currency = 'PLN') => {
    return new Intl.NumberFormat('pl-PL', { style: 'currency', currency }).format(amount);
  };

  // Linie do symulacji kodu rabatowego w Storefront API.
  //
  // Nagrody progowe (_auto_gift) MUSZĄ zostać pominięte. Powód: produkt-nagroda bywa
  // nieopublikowany w kanale Online Store (tak jest z zestawem BTS), a wtedy Storefront
  // API odrzuca CAŁĄ mutację cartCreate błędem "Towar o ID ... nie istnieje". Kod niżej
  // tłumaczył każdy userError na komunikat „Kod nieprawidłowy”, więc od progu, na którym
  // taka nagroda wpada do koszyka, ŻADEN kod rabatowy nie dawał się zastosować
  // (zgłoszenie klienta 3.09.2026: „kod nie działa jak mam nagrody w koszyku”).
  //
  // Pominięcie ich jest też merytorycznie poprawne: nagrody kosztują 1 zł dzięki
  // rabatowi automatycznemu, którego kod rabatowy i tak nie dotyczy - kwoty rabatu
  // policzone bez tych linii zgadzają się co do grosza z koszykiem natywnym.
  const giftLine = item => !!(item.properties && item.properties._auto_gift !== undefined);
  const stable = value => {
    if (Array.isArray(value)) return value.map(stable);
    if (value && typeof value === 'object') return Object.keys(value).sort().reduce((out, key) => {
      out[key] = stable(value[key]); return out;
    }, {});
    return value;
  };
  const savedCodeKey = () => JSON.stringify(getAllCodes());
  const nativeCodes = cart => {
    const applications = [...(cart.cart_level_discount_applications || [])];
    (cart.items || []).forEach(item => {
      [...(item.line_level_discount_allocations || []), ...(item.discount_allocations || [])]
        .forEach(allocation => { if (allocation.discount_application) applications.push(allocation.discount_application); });
    });
    return applications.filter(application => application.type === 'discount_code' && typeof application.title === 'string')
      .map(application => application.title.trim()).filter(Boolean);
  };
  const combinedCodes = (cart, requested = getAllCodes()) => {
    const seen = new Set();
    return [...requested, ...nativeCodes(cart)].filter(code => {
      const key = code.toUpperCase();
      if (seen.has(key)) return false;
      seen.add(key); return true;
    });
  };
  const cartFingerprint = cart => JSON.stringify(stable({
    currency: cart.currency,
    lines: (cart.items || []).filter(item => !giftLine(item)).map(item => ({
      variant: String(item.variant_id), quantity: item.quantity,
      properties: item.properties || {},
      sellingPlan: item.selling_plan_allocation?.selling_plan?.id || item.selling_plan || null,
      finalPrice: item.final_line_price, originalPrice: item.original_line_price,
      allocations: item.discount_allocations || item.line_level_discount_allocations || []
    })).sort((a, b) => JSON.stringify(stable(a)).localeCompare(JSON.stringify(stable(b)))),
    // Allocated cart totals can include gifts. Rule identity and merchandise line
    // allocations retain native-discount changes without invalidating for gifts.
    nativeDiscounts: (cart.cart_level_discount_applications || []).map(d => ({
      title: d.title, type: d.type, value: d.value, valueType: d.value_type,
      targetType: d.target_type, targetSelection: d.target_selection
    }))
  }));
  const signature = cart => cartFingerprint(cart) + '|' + savedCodeKey();
  const buildDiscountLines = cartData => (cartData.items || []).filter(item => !giftLine(item)).map(item => {
    const line = { merchandiseId: `gid://shopify/ProductVariant/${item.variant_id}`, quantity: item.quantity };
    const attributes = Object.entries(item.properties || {}).filter(([, value]) => value !== null && value !== undefined)
      .map(([key, value]) => ({ key, value: String(value) }));
    if (attributes.length) line.attributes = attributes;
    const plan = item.selling_plan_allocation?.selling_plan?.id || item.selling_plan;
    if (plan) line.sellingPlanId = String(plan).startsWith('gid://') ? String(plan) : `gid://shopify/SellingPlan/${plan}`;
    return line;
  });
  const staleError = () => new Error('Stale discount calculation');
  const calculationCache = new Map();
  let latestMerchandiseFingerprint = null;
  let controllerVersion = 0;
  const cents = amount => {
    if ((typeof amount !== 'string' && typeof amount !== 'number') || (typeof amount === 'string' && !amount.trim())) throw new Error('Nieprawidłowa kwota rabatu');
    const parsed = Number(amount);
    if (!Number.isFinite(parsed) || parsed < 0) throw new Error('Nieprawidłowa kwota rabatu');
    return Math.round(parsed * 100);
  };
  const requestCalculation = (cartData, codes = getAllCodes()) => {
    codes = combinedCodes(cartData, codes);
    const fingerprint = cartFingerprint(cartData);
    const expectedCodes = savedCodeKey();
    latestMerchandiseFingerprint = fingerprint;
    const key = fingerprint + '|' + JSON.stringify(codes);
    const ensureCurrent = () => {
      if (savedCodeKey() !== expectedCodes || latestMerchandiseFingerprint !== fingerprint) throw staleError();
    };
    const cached = calculationCache.get(key);
    if (cached && Date.now() - cached.created < 15000) {
      return cached.promise.then(result => { ensureCurrent(); return result; });
    }
    const lines = buildDiscountLines(cartData);
    const query = `mutation cartCreate($lines: [CartLineInput!], $discountCodes: [String!]) {
      cartCreate(input: { lines: $lines, discountCodes: $discountCodes }) {
        cart {
          cost { totalAmount { amount currencyCode } subtotalAmount { amount currencyCode } }
          discountCodes { code applicable }
          discountAllocations { discountedAmount { amount } targetType }
          lines(first: 100) { edges { node {
            cost { subtotalAmount { amount } totalAmount { amount } }
            merchandise { ... on ProductVariant { id } }
            discountAllocations { discountedAmount { amount } }
          } } }
        }
        userErrors { message }
      }
    }`;
    const promise = (lines.length ? fetch(`https://${SHOP_DOMAIN}/api/2026-07/graphql.json`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN },
      body: JSON.stringify({ query, variables: { lines, discountCodes: codes } })
    }).then(async res => {
      if (!res.ok) throw new Error('Nie udało się przeliczyć rabatu');
      const json = await res.json();
      const result = json.data?.cartCreate;
      if (json.errors?.length || result?.userErrors?.length || !result?.cart) throw new Error('Nie udało się przeliczyć rabatu');
      const cart = result.cart;
      const applicable = (cart.discountCodes || []).filter(code => code.applicable).map(code => code.code.toUpperCase());
      const currency = cart.cost.subtotalAmount.currencyCode;
      if (currency !== cartData.currency) throw new Error('Waluta rabatu nie zgadza się z koszykiem');
      const orderSavings = (cart.discountAllocations || []).filter(allocation => allocation.targetType === 'LINE_ITEM')
        .reduce((sum, allocation) => sum + cents(allocation.discountedAmount.amount), 0);
      // Storefront subtotal already includes line/automatic discounts. Subtract
      // only cart-level merchandise allocations, never tax or shipping.
      const merchandiseCents = Math.max(0, cents(cart.cost.subtotalAmount.amount) - orderSavings);
      const priceMap = {}, discountMap = {};
      let totalSavings = orderSavings / 100;
      cart.lines.edges.forEach(({node:line}) => {
        const variantId = line.merchandise.id.split('/').pop();
        priceMap[variantId] = { finalPrice: cents(line.cost.totalAmount.amount) / 100, originalPrice: cents(line.cost.subtotalAmount.amount) / 100 };
        (line.discountAllocations || []).forEach(allocation => {
          const amount = cents(allocation.discountedAmount.amount) / 100;
          totalSavings += amount;
          discountMap[variantId] = (discountMap[variantId] || 0) + amount;
        });
      });
      return { merchandiseCents, totalAmount: merchandiseCents / 100, currency, priceMap, discountMap, totalSavings, fingerprint, codes: codes.slice(), applicableCodes: applicable };
    }) : Promise.resolve({ merchandiseCents: 0, totalAmount: 0, currency: cartData.currency, priceMap: {}, discountMap: {}, totalSavings: 0, fingerprint, codes: codes.slice(), applicableCodes: [] }))
      .then(result => { ensureCurrent(); return result; });
    calculationCache.set(key, { promise, created: Date.now() });
    promise.catch(() => { if (calculationCache.get(key)?.promise === promise) calculationCache.delete(key); });
    // Bound this short-lived cache during long shopping sessions.
    if (calculationCache.size > 20) calculationCache.delete(calculationCache.keys().next().value);
    return promise;
  };
  const qualifyingTotal = cart => getAllCodes().length ? requestCalculation(cart).then(result => result.merchandiseCents) : Promise.resolve(null);
  const verifyCalculation = async (cartData, expectedCodes, version) => {
    const res = await fetch('/cart.js', { cache: 'no-store' });
    if (!res.ok) throw new Error('Nie udało się odświeżyć koszyka');
    const current = await res.json();
    if (version !== controllerVersion || expectedCodes !== savedCodeKey() || cartFingerprint(current) !== cartFingerprint(cartData)) throw staleError();
    return current;
  };
  const emitDiscount = (name, result) => document.documentElement.dispatchEvent(new CustomEvent(name, {
    bubbles: true, detail: result ? { merchandiseTotal: result.merchandiseCents, codes: result.codes.slice() } : { codes: getAllCodes() }
  }));
  window.CartDiscounts = { getCodes: () => getAllCodes().slice(), signature, qualifyingTotal };


  const showToast = (message, type = 'success') => {
    const toast = $('#cart-toast');
    if (!toast) return;
    toast.textContent = message;
    toast.className = 'cart-toast ' + type;
    requestAnimationFrame(() => toast.classList.add('show'));
    setTimeout(() => toast.classList.remove('show'), 2200);
  };

  const animateEl = (el, className, duration = 350) => {
    if (!el) return;
    el.classList.remove(className);
    void el.offsetWidth;
    el.classList.add(className);
    setTimeout(() => el.classList.remove(className), duration);
  };
  const setCartTotal = (amount, currency) => {
    $$('#cart-footer-total-price, [data-cart-discount-total]').forEach(element => {
      element.textContent = formatMoney(amount, currency);
      animateEl(element, 'price-updated');
    });
  };
  const displayedTotal = (snapshot, cart) => snapshot.totalAmount + (cart.items || [])
    .filter(giftLine).reduce((sum, item) => sum + Math.min(Number(item.final_line_price) || 0, 100), 0) / 100;

  // Animacja dla gratisu - WEJŚCIE
  // Pamięć „już animowany" trzyma window.__giftAnim (layout/theme.liquid) w
  // sessionStorage, kluczowana data-line-key. Klasa CSS nie mogła być strażnikiem,
  // bo ginie razem z węzłem przy każdej przebudowie innerHTML szuflady — i gratis
  // animował się ponownie po każdym przerysowaniu koszyka.
  const animateGiftEntry = (el) => {
    if (!el) return;
    const api = window.__giftAnim;
    const lineKey = el.dataset ? el.dataset.lineKey : null;
    if (api && lineKey) {
      if (!api.shouldAnimate(lineKey)) { el.classList.add('gift-animated'); return; }
      api.markAnimated(lineKey);
    } else if (el.classList.contains('gift-animated')) {
      return; // fallback: brak API albo brak klucza — stara semantyka klasowa
    }
    el.classList.add('gift-animated');
    el.classList.add('gift-entering');
    setTimeout(() => el.classList.remove('gift-entering'), 1600);
  };

  // ============================================
  // NOWE: Animacja dla gratisu - WYJŚCIE
  // ============================================
  const animateGiftRemoval = (el) => {
    return new Promise(resolve => {
      if (!el) { resolve(); return; }
      el.classList.add('gift-removing');
      el.addEventListener('animationend', () => {
        el.remove();
        resolve();
      }, { once: true });
      // Safety timeout - gdyby animationend nie odpalił
      setTimeout(() => {
        if (el.parentNode) el.remove();
        resolve();
      }, 600);
    });
  };

  // ============================================
  // NOWE: Śledzenie stanu gratisów
  // ============================================
  const getGiftVariantIds = () => {
    const gifts = new Set();
    document.querySelectorAll('.is-free-gift').forEach(el => {
      const vid = el.dataset.variantId;
      if (vid) gifts.add(vid);
    });
    return gifts;
  };

  // Snapshot gratisów PRZED aktualizacją koszyka
  let giftsBefore = new Set();
  
  const snapshotGifts = () => {
    giftsBefore = getGiftVariantIds();
  };

  // Po odświeżeniu koszyka (section rendering) - porównaj i animuj
  const animateGiftChanges = () => {
    const giftsAfter = getGiftVariantIds();
    
    // Nowe gratisy (pojawiły się po aktualizacji)
    giftsAfter.forEach(vid => {
      if (!giftsBefore.has(vid)) {
        const el = document.querySelector(`.is-free-gift[data-variant-id="${vid}"]`);
        if (el && !el.classList.contains('gift-animated')) {
          animateGiftEntry(el);
          el.classList.add('gift-animated');
        }
      }
    });
    
    // Usunięte gratisy (były przed, nie ma po) - 
    // Te elementy już nie istnieją w DOM po server-side renderze,
    // więc musimy je obsłużyć PRZED re-renderem (patrz handleCartSectionRefresh)
  };

  const setDiscountPending = (pending) => {
    const cart = $('#mini-cart');
    if (cart) cart.classList.toggle('is-discount-pending', pending);
  };

  // ============================================
  // OBSŁUGA KODÓW RABATOWYCH
  // ============================================
  
  const saveDiscounts = (codes) => {
    localStorage.setItem('icedstuff_discounts', JSON.stringify(codes));
  };
  
  const getDiscounts = () => {
    try { 
      const data = JSON.parse(localStorage.getItem('icedstuff_discounts'));
      return Array.isArray(data) ? data : [];
    } catch { return []; }
  };
  
  const clearDiscounts = () => localStorage.removeItem('icedstuff_discounts');
  
  const addDiscount = (code, savings, currency) => {
    const discounts = getDiscounts();
    if (!discounts.find(d => d.code.toUpperCase() === code.toUpperCase())) {
      discounts.push({ code, savings, currency });
      saveDiscounts(discounts);
    }
  };
  
  const removeDiscountByCode = (codeToRemove) => {
    let discounts = getDiscounts();
    discounts = discounts.filter(d => d.code.toUpperCase() !== codeToRemove.toUpperCase());
    saveDiscounts(discounts);
  };
  
  const isCodeAlreadyUsed = (code) => {
    const discounts = getDiscounts();
    return discounts.some(d => d.code.toUpperCase() === code.toUpperCase());
  };
  
  const getAllCodes = () => {
    return getDiscounts().map(d => d.code);
  };

  // Kody współpracy (16.10): każdy influencer ma własny kod ze słowem COLLAB (rabat na produkty). Wpisanie go
  // dokłada COLLABSHIP, czyli darmową dostawę. W Shopify to dwa osobne rabaty (jeden kod nie daje rabatu na
  // produkty i dostawy naraz), oba muszą mieć włączone łączenie. Usunięcie jednego zdejmuje oba. Kod dostawy
  // pokazuje napis zamiast kwoty i nie dzieli oszczędności.
  const SHIPPING_CODE = 'COLLABSHIP';
  const SHIPPING_LABEL = 'Darmowa dostawa';
  const upperCode = code => String(code || '').trim().toUpperCase();
  const isLinkedShipping = code => upperCode(code) === SHIPPING_CODE;
  const linkedShipping = code => {
    const c = upperCode(code);
    return c !== SHIPPING_CODE && c.includes('COLLAB') ? SHIPPING_CODE : null;
  };
  // Co zdjąć razem z kodem: przy COLLABSHIP kody współpracy, przy kodzie współpracy COLLABSHIP (o ile nie zostaje inny)
  const partnersToDrop = code => {
    if (isLinkedShipping(code)) return getAllCodes().filter(c => linkedShipping(c));
    if (!linkedShipping(code)) return [];
    return getAllCodes().some(c => linkedShipping(c) && upperCode(c) !== upperCode(code)) ? [] : [SHIPPING_CODE];
  };
  const moneyCodes = () => getAllCodes().filter(code => !isLinkedShipping(code));
  const spreadSavings = (discounts, total) => {
    const paid = discounts.filter(d => !isLinkedShipping(d.code)).length || 1;
    discounts.forEach(d => { d.savings = isLinkedShipping(d.code) ? 0 : total / paid; });
  };
  
  const getTotalSavings = () => {
    return getDiscounts().reduce((sum, d) => sum + (d.savings || 0), 0);
  };

  const tagIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="new-discount-card__icon"><path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"></path><circle cx="7.5" cy="7.5" r=".5" fill="currentColor"></circle></svg>`;

  const renderDiscountPills = (animate = true) => {
    const discounts = getDiscounts();
    const container = $('#fcoupon-active-container');
    const pillWrapper = $('#fcoupon-pill-wrapper');
    const input = $('#cart-discount-code');
    const msg = $('#discount-message');

    if (discounts.length > 0 && container && pillWrapper) {
      let html = '';
      discounts.forEach((discount, index) => {
        html += `
          <div class="new-discount-card" data-discount-code="${discount.code}">
            <div class="new-discount-card__left">
              ${tagIcon}
              <span class="new-discount-card__code">${discount.code}</span>
            </div>
            <div class="new-discount-card__right">
              <span class="new-discount-card__amount">${isLinkedShipping(discount.code) ? SHIPPING_LABEL : '-' + formatMoney(discount.savings, discount.currency || 'PLN')}</span>
              <button class="new-discount-card__remove fcoupon-pill__remove" data-code="${discount.code}" aria-label="Usuń kod">×</button>
            </div>
          </div>`;
      });
      
      pillWrapper.innerHTML = html;
      
      if (input) { input.value = ''; input.classList.remove('input-error'); input.classList.add('input-success'); }
      if (msg) msg.style.display = 'none';
      
      container.classList.remove('removing');
      container.style.display = 'block';
      
      if (animate) container.style.animation = 'none';
      if (animate) { void container.offsetWidth; container.style.animation = ''; }
      
    } else if (container) {
      container.style.display = 'none';
      if (input) input.classList.remove('input-success');
    }
  };

  const updateCartPrices = async () => {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      const countEl = $('#cart-item-count');
      if (countEl) {
        countEl.textContent = cart.item_count;
        animateEl(countEl, 'qty-updated');
      }

      setCartTotal(cart.total_price / 100, cart.currency);

      cart.items.forEach(item => {
        const lineItem = $(`[data-line-key="${item.key}"]`);
        if (!lineItem || lineItem.dataset.isGift === 'true') return;
        
        const priceEl = lineItem.querySelector('.js-line-price');
        const compareEl = lineItem.querySelector('.js-line-original-price');
        
        if (priceEl) {
          priceEl.textContent = formatMoney(item.final_line_price / 100, cart.currency);
          animateEl(priceEl, 'price-updated');
        }
        if (compareEl) {
          if (item.original_line_price > item.final_line_price) {
            compareEl.textContent = formatMoney(item.original_line_price / 100, cart.currency);
            compareEl.style.display = 'inline';
          } else if (!compareEl.dataset.discountApplied) { 
             compareEl.style.display = 'none';
          }
        }
      });

      const shippingBar = $('#free-shipping-bar');
      if (shippingBar) {
        const threshold = parseFloat(shippingBar.getAttribute('threshold'));
        const progress = Math.min(1, cart.total_price / threshold);
        shippingBar.style.setProperty('--progress', progress);
        const textEl = shippingBar.querySelector('.shipping-bar__text');
        if (textEl) {
          textEl.textContent = cart.total_price >= threshold 
            ? 'Masz darmową dostawę!' 
            : `Brakuje ${formatMoney((threshold - cart.total_price) / 100, cart.currency)} do darmowej dostawy`;
        }
      }
    } catch (err) { console.error('updateCartPrices error:', err); }
  };

  const calculateDiscountOperation = async (newCode, silent = false, overrideLock = false) => {
    if (!newCode || (!overrideLock && isProcessing)) return;
    
    const normalizedNewCode = newCode.trim().toUpperCase();

    if (isLinkedShipping(normalizedNewCode) && !isCodeAlreadyUsed(normalizedNewCode)) {
      if (!silent) {
        const msg = $('#discount-message');
        const input = $('#cart-discount-code');
        if (msg) { msg.textContent = 'Ten kod dodaje się sam razem z kodem współpracy'; msg.style.display = 'block'; }
        if (input) { input.classList.add('input-error'); }
        showToast('Ten kod dodaje się sam razem z kodem współpracy', 'warning');
      }
      return;
    }

    if (isCodeAlreadyUsed(normalizedNewCode)) {
      if (!silent) {
        showToast('Ten kod jest już aktywny!', 'warning');
        const input = $('#cart-discount-code');
        if (input) { input.classList.add('input-error'); }
      }
      return;
    }
    
    const version = ++controllerVersion;
    isProcessing = true;
    setDiscountPending(true);
    
    const btn = $('#apply-discount-btn');
    const input = $('#cart-discount-code');
    
    if (!silent && btn) {
      btn.classList.add('is-loading');
      btn.innerHTML = '<div class="btn-spinner"></div>';
    }

    try {
      const cartRes = await fetch('/cart.js');
      const cartData = await cartRes.json();
      if (cartData.item_count === 0) throw new Error('Koszyk jest pusty');

      const existingCodes = getAllCodes();
      // Kod współpracy: COLLABSHIP liczymy w tym samym zapytaniu i dokładamy tylko, gdy Shopify go przyjmie
      // (kod influencera musi mieć włączone łączenie z rabatami na wysyłkę, inaczej kasa by go odrzuciła).
      const shippingCode = linkedShipping(normalizedNewCode);
      const tryShipping = shippingCode && !isCodeAlreadyUsed(shippingCode) ? [shippingCode] : [];
      const allCodes = [...existingCodes, normalizedNewCode, ...tryShipping];
      const expectedCodes = savedCodeKey();
      const snapshot = await requestCalculation(cartData, allCodes);
      const currentCart = await verifyCalculation(cartData, expectedCodes, version);
      if (!snapshot.applicableCodes.includes(normalizedNewCode)) {
        // Zestaw w koszyku: jego kod nie łączy się z innymi, więc kod sklepu nie wejdzie. Wyjaśnienie zamiast ogólnego błędu.
        const hasBundle = (cartData.items || []).some(item => item.properties && item.properties._bundle);
        throw new Error(hasBundle
          ? 'Cena zestawu już zawiera rabat. Kod promocyjny nie łączy się z zestawem.'
          : 'Kod nie działa na te produkty lub nie łączy się z aktualną zniżką');
      }
      const { totalAmount, currency, priceMap, discountMap, totalSavings: totalSavingsFromAPI } = snapshot;

      const previousTotalSavings = getTotalSavings();
      const newCodeSavings = Math.max(0, totalSavingsFromAPI - previousTotalSavings);
      
      addDiscount(normalizedNewCode, newCodeSavings, currency);
      if (tryShipping.length && snapshot.applicableCodes.includes(shippingCode)) addDiscount(shippingCode, 0, currency);

      if (existingCodes.length > 0 && totalSavingsFromAPI > 0) {
        const discounts = getDiscounts();
        spreadSavings(discounts, totalSavingsFromAPI);
        saveDiscounts(discounts);
      }
      
      renderDiscountPills(!silent);

      if (!silent && btn) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-success');
        btn.innerHTML = '<svg class="btn-check" viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg>';
        setTimeout(() => {
          btn.classList.remove('is-success');
          btn.innerHTML = '<span>Zastosuj</span>';
        }, 1200);
      }

      setCartTotal(displayedTotal(snapshot, currentCart), currency);

      let delay = 0;
      $$('.new-line-item').forEach(item => {
        const variantId = item.dataset.variantId;
        if (item.dataset.isGift === 'true') return;
        
        const badgeContainer = item.querySelector('.badges-container');
        const priceEl = item.querySelector('.js-line-price');
        const compareEl = item.querySelector('.js-line-original-price');

        setTimeout(() => {
          if (version !== controllerVersion) return;
          let isOnePlnProduct = false;
          if (priceMap[variantId] && priceMap[variantId].finalPrice === 1.00) {
             isOnePlnProduct = true;
          }

          if (isOnePlnProduct) {
              const existingBadge = badgeContainer?.querySelector('.custom-discount-badge');
              if (existingBadge) existingBadge.remove();
          } 
          else if (badgeContainer && discountMap[variantId]) {
            let badge = badgeContainer.querySelector('.custom-discount-badge');
            if (!badge) {
              badge = document.createElement('span');
              badge.className = 'new-badge custom-discount-badge badge-love';
              badgeContainer.appendChild(badge);
            }
            const allActiveCodes = moneyCodes().join(', ');
            badge.textContent = `${allActiveCodes} (-${formatMoney(discountMap[variantId], currency)})`;
          }

          if (priceMap[variantId]) {
            const { finalPrice, originalPrice } = priceMap[variantId];
            if (priceEl) {
              priceEl.textContent = formatMoney(finalPrice, currency);
              animateEl(priceEl, 'price-updated');
            }
            if (compareEl) {
              if (finalPrice < originalPrice) {
                compareEl.textContent = formatMoney(originalPrice, currency);
                compareEl.style.display = 'inline';
                compareEl.dataset.discountApplied = 'true';
              }
            }
          }
          item.classList.add('line-updating');
        }, delay);
        delay += 50;
      });

      emitDiscount('discount:applied', snapshot);
      emitDiscount('discount:updated', snapshot);
      if (!silent) showToast('Kod rabatowy zastosowany!', 'success');

    } catch (err) {
      if (!silent && !/stale/i.test(err.message)) {
        const msg = $('#discount-message');
        if (msg) { msg.textContent = err.message; msg.style.display = 'block'; }
        if (input) { input.classList.add('input-error'); input.classList.remove('input-success'); }
        if (btn) { btn.innerHTML = '<span>Zastosuj</span>'; btn.classList.remove('is-loading'); }
        showToast(err.message, 'error');
      }
      if (/stale/i.test(err.message)) {
        if (btn) { btn.innerHTML = '<span>Zastosuj</span>'; btn.classList.remove('is-loading', 'is-success'); }
        if (input) input.classList.remove('input-success', 'input-error');
      }
      throw err;
    } finally {
      if (btn) btn.classList.remove('is-loading');
      if (version === controllerVersion) {
        setDiscountPending(false);
        isProcessing = false;
      }
    }
  };

  const recalculateAllDiscountsOperation = async () => {
    const codes = getAllCodes();
    if (codes.length === 0) return;
    
    const version = ++controllerVersion;
    isProcessing = true;
    setDiscountPending(true);

    try {
      const cartRes = await fetch('/cart.js');
      const cartData = await cartRes.json();
      const expectedCodes = savedCodeKey();
      const snapshot = await requestCalculation(cartData, codes);
      const currentCart = await verifyCalculation(cartData, expectedCodes, version);
      const { totalAmount, currency, priceMap, discountMap, totalSavings } = snapshot;

      const discounts = getDiscounts();
      if (discounts.length > 0) {
        spreadSavings(discounts, totalSavings);
        discounts.forEach(d => { d.currency = currency; });
        saveDiscounts(discounts);
      }

      renderDiscountPills(false);

      setCartTotal(displayedTotal(snapshot, currentCart), currency);

      $$('.new-line-item').forEach(item => {
        const variantId = item.dataset.variantId;
        if (item.dataset.isGift === 'true') return;
        
        const badgeContainer = item.querySelector('.badges-container');
        const priceEl = item.querySelector('.js-line-price');
        const compareEl = item.querySelector('.js-line-original-price');

        let isOnePlnProduct = priceMap[variantId] && priceMap[variantId].finalPrice === 1.00;

        if (isOnePlnProduct) {
           const existingBadge = badgeContainer?.querySelector('.custom-discount-badge');
           if (existingBadge) existingBadge.remove();
        } 
        else if (badgeContainer && discountMap[variantId]) {
          let badge = badgeContainer.querySelector('.custom-discount-badge');
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'new-badge custom-discount-badge badge-love';
            badgeContainer.appendChild(badge);
          }
          const allActiveCodes = moneyCodes().join(', ');
          badge.textContent = `${allActiveCodes} (-${formatMoney(discountMap[variantId], currency)})`;
        }

        if (priceMap[variantId]) {
          const { finalPrice, originalPrice } = priceMap[variantId];
          if (priceEl) {
            priceEl.textContent = formatMoney(finalPrice, currency);
            animateEl(priceEl, 'price-updated');
          }
          if (compareEl) {
            if (finalPrice < originalPrice) {
              compareEl.textContent = formatMoney(originalPrice, currency);
              compareEl.style.display = 'inline';
              compareEl.dataset.discountApplied = 'true';
            }
          }
        }
      });

      emitDiscount('discount:updated', snapshot);

    } catch (err) {
      if (!/stale/i.test(err.message)) console.error('recalculateAllDiscounts error:', err);
      throw err;
    } finally {
      if (version === controllerVersion) {
        setDiscountPending(false);
        isProcessing = false;
      }
    }
  };

  const removeDiscountOperation = async (codeToRemove) => {
    // Kod współpracy schodzi razem z COLLABSHIP (i odwrotnie)
    const doomed = [codeToRemove, ...partnersToDrop(codeToRemove)];
    const doomedKeys = doomed.map(upperCode);
    let nativeDiscountRemoved = false;
    ++controllerVersion;
    setDiscountPending(false);
    isProcessing = false;
    // Checkout can persist the saved coupon onto the native cart. Remove that
    // copy before clearing local state, while retaining unrelated native codes.
    try {
      const cartResponse = await fetch('/cart.js', { cache: 'no-store' });
      if (!cartResponse.ok) throw new Error('Nie udało się odczytać kodów koszyka');
      const cart = await cartResponse.json();
      if (!Array.isArray(cart.items)) throw new Error('Nieprawidłowa odpowiedź koszyka');
      const activeNativeCodes = combinedCodes(cart, []);
      const remainingNativeCodes = activeNativeCodes.filter(code => !doomedKeys.includes(code.toUpperCase()));
      if (remainingNativeCodes.length !== activeNativeCodes.length) {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: remainingNativeCodes.join(',') })
        });
        if (!response.ok) throw new Error('Nie udało się usunąć kodu z koszyka');
        const updatedCart = await response.json();
        if (!Array.isArray(updatedCart.items) || nativeCodes(updatedCart).some(code => doomedKeys.includes(code.toUpperCase()))) {
          throw new Error('Kod nadal jest aktywny w koszyku');
        }
        nativeDiscountRemoved = true;
      }
    } catch (err) {
      showToast('Nie udało się usunąć kodu rabatowego. Spróbuj ponownie.', 'error');
      console.error('[cart-discounts] remove:', err);
      throw err;
    }
    doomed.forEach(removeDiscountByCode);
    const cards = Array.from($$('.new-discount-card')).filter(card => doomedKeys.includes(upperCode(card.dataset.discountCode)));
    const input = $('#cart-discount-code');

    if (cards.length) {
      cards.forEach(card => { card.style.animation = 'fadeOut 0.2s ease-out forwards'; });
      await new Promise(r => setTimeout(r, 200));
      cards.forEach(card => card.remove());
    }
    
    const remainingCodes = getAllCodes();
    if (remainingCodes.length > 0) {
      await recalculateAllDiscounts();
    } else {
      const container = $('#fcoupon-active-container');
      if (container) container.style.display = 'none';
      if (input) input.classList.remove('input-success', 'input-error');
      
      $$('.custom-discount-badge').forEach(el => {
        el.style.animation = 'fadeOut 0.2s ease-out forwards';
        setTimeout(() => el.remove(), 200);
      });
      
      await updateCartPrices();
    }
    
    emitDiscount('discount:removed');
    if (!getAllCodes().length) emitDiscount('discount:updated');
    // Native discount applications can change line keys. Rebuild the drawer
    // even if reward eligibility stays unchanged and the engine makes no edit.
    if (nativeDiscountRemoved) document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: {} }));
    showToast('Kod rabatowy usunięty');
  };

  // ============================================
  // ULEPSZONA OBSŁUGA ILOŚCI - Z ANIMACJĄ GRATISÓW
  // ============================================
  
  const updateQuantityOperation = async (lineKey, newQty, lineItem) => {
    const qtySelector = lineItem?.querySelector('.new-quantity-selector');
    const qtyInput = lineItem?.querySelector('.new-qty-input');
    
    if (qtySelector) {
      qtySelector.classList.add('is-processing', 'qty-changing');
    }
    // Przycisków nie wyłączamy — patrz komentarz przy .is-processing.
    if (lineItem) lineItem.classList.add('is-loading');

    // *** NOWE: Zapamiętaj gratisy PRZED zmianą ***
    snapshotGifts();

    try {
      // X-MC-INLINE: ta zmiana jest juz w calosci obsluzona w miejscu (ceny, total,
      // licznik, shipping bar) - cart-recs.js widzac ten naglowek NIE wymusza
      // pelnego rerenderu szuflady przez cart:refresh (to byl ten "koszyk
      // odswieza sie kilka razy" ~4-5s po kliknieciu).
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-MC-INLINE': '1' },
        body: JSON.stringify({ id: lineKey, quantity: newQty })
      });
      const cart = await res.json();

      // Bez tego sprawdzenia odpowiedź 422/429 (obiekt błędu, BEZ pola items)
      // leciała dalej i wywracała się na cart.items.find — a klient dostawał
      // tylko generyczne „Wystąpił błąd" zamiast komunikatu ze Shopify.
      if (!res.ok) {
        throw new Error((cart && (cart.description || cart.message)) || ('Błąd koszyka (' + res.status + ')'));
      }

      if (newQty === 0) {
        if (lineItem) {
          lineItem.classList.add('item-removing');
          await new Promise(r => setTimeout(r, 200));
          lineItem.remove();
        }
        showToast('Produkt usunięty');
      } else {
        const serverItem = cart.items.find(i => i.key === lineKey);
        const actualQty = serverItem ? serverItem.quantity : newQty;

        if (qtyInput) {
          qtyInput.value = actualQty;
          animateEl(qtyInput, 'qty-updated');
        }

        // Rerender szuflady w trakcie requestu podmienia DOM - zlapana wyzej
        // referencja moze byc odlaczona, a widoczny (nowy) input zostawal ze stara
        // wartoscia; kolejny klik liczyl wtedy od zanizonej ilosci (np. 4 -> 2).
        // Dlatego ilosc wpisujemy tez do zywego inputu wyszukanego po lineKey.
        const liveInput = document.querySelector('.new-qty-input[data-line-key="' + (window.CSS && CSS.escape ? CSS.escape(lineKey) : lineKey) + '"]');
        if (liveInput && liveInput !== qtyInput) {
          liveInput.value = actualQty;
        }
        
        if (serverItem && lineItem) {
          const priceEl = lineItem.querySelector('.js-line-price');
          const compareEl = lineItem.querySelector('.js-line-original-price');
          
          if (priceEl) {
            priceEl.textContent = formatMoney(serverItem.final_line_price / 100, cart.currency);
            animateEl(priceEl, 'price-updated');
          }
          if (compareEl) {
            if (serverItem.original_line_price > serverItem.final_line_price) {
              compareEl.textContent = formatMoney(serverItem.original_line_price / 100, cart.currency);
              compareEl.style.display = 'inline';
            } else if (!compareEl.dataset.discountApplied) {
              compareEl.style.display = 'none';
            }
          }
          lineItem.classList.add('line-updating');
        }
      }

      // Gratisy, ktore po tej zmianie straszyly pelna cena (spadek ponizej progu
      // wylacza rabat natychmiast, a silnik nagrod usuwa linie dopiero za chwile) -
      // nie pokazujemy ich w sumie ani liczniku, bo za sekunde znikna z koszyka.
      let displayTotal = cart.total_price;
      let displayCount = cart.item_count;
      cart.items.forEach((it) => {
        if (it.properties && it.properties._auto_gift !== undefined && it.final_line_price > 100) {
          displayTotal -= it.final_line_price;
          displayCount -= it.quantity;
        }
      });

      // Aktualizuj nagłówek i total
      const countEl = $('#cart-item-count');
      if (countEl) {
        countEl.textContent = displayCount;
        animateEl(countEl, 'qty-updated');
      }

      // Dymek na ikonie koszyka w headerze aktualizowal sie dotad "przy okazji"
      // pelnego cart:refresh od cart-recs - po jego wyciszeniu robimy to wprost.
      document.querySelectorAll('cart-count').forEach((el) => { el.innerText = displayCount; });

      // Ostatnia pozycja usunieta: szablon pustego koszyka renderuje Liquid,
      // wiec to jedyny przypadek, gdy prosimy szuflade o pelny rerender.
      if (cart.item_count === 0) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: {} }));
      }
      
      setCartTotal(displayTotal / 100, cart.currency);

      // Aktualizuj shipping bar
      const shippingBar = $('#free-shipping-bar');
      if (shippingBar) {
        const threshold = parseFloat(shippingBar.getAttribute('threshold'));
        shippingBar.style.setProperty('--progress', Math.min(1, displayTotal / threshold));
        const textEl = shippingBar.querySelector('.shipping-bar__text');
        if (textEl) {
          textEl.textContent = displayTotal >= threshold
            ? 'Masz darmową dostawę!'
            : `Brakuje ${formatMoney((threshold - displayTotal) / 100, cart.currency)} do darmowej dostawy`;
        }
      }

      // *** NOWE: Sprawdź czy gratisy się zmieniły na podstawie danych z API ***
      // Sprawdź cart.items - które produkty mają final_line_price <= 100 (gratis)
      const serverGiftVariantIds = new Set();
      cart.items.forEach(item => {
        if (item.final_line_price <= 100) {
          serverGiftVariantIds.add(String(item.variant_id));
        }
      });

      // Gratisy które zniknęły - animuj wyjście
      const giftsToRemove = [];
      giftsBefore.forEach(vid => {
        if (!serverGiftVariantIds.has(vid)) {
          const el = document.querySelector(`.is-free-gift[data-variant-id="${vid}"]`);
          if (el) giftsToRemove.push(el);
        }
      });
      
      if (giftsToRemove.length > 0) {
        await Promise.all(giftsToRemove.map(el => animateGiftRemoval(el)));
      }

      // Gratisy które się pojawiły - muszą być już w DOM
      // Jeśli koszyk jest renderowany server-side (section rendering), 
      // nowe gratisy pojawią się dopiero po renderze sekcji.
      // Dla tego case'u obsługujemy w cart:refresh event.
      // Ale jeśli element już jest w DOM (np. ukryty), animuj go:
      serverGiftVariantIds.forEach(vid => {
        if (!giftsBefore.has(vid)) {
          const el = document.querySelector(`.is-free-gift[data-variant-id="${vid}"]`);
          if (el) {
            animateGiftEntry(el);
            el.classList.add('gift-animated');
          }
        }
      });

    } catch (err) {
      console.error('[mini-cart] updateQuantity:', err);
      showToast((err && err.message) ? err.message : 'Wystąpił błąd', 'error');
      
      try {
        const cartRes = await fetch('/cart.js');
        const cartData = await cartRes.json();
        const serverItem = cartData.items.find(i => i.key === lineKey);
        if (serverItem && qtyInput) {
          qtyInput.value = serverItem.quantity;
        }
      } catch {}
      throw err;
      
    } finally {
      if (qtySelector) {
        qtySelector.classList.remove('is-processing', 'qty-changing');
      }
      if (lineItem) lineItem.classList.remove('is-loading');

      // Przeliczenie rabatów (pełna tura do Storefront GraphQL) celowo POZA
      // ścieżką krytyczną — wcześniej trzymało wiersz w stanie „przetwarzanie"
      // przez setki milisekund.
      const codes = getAllCodes();
      if (codes.length > 0) {
        Promise.resolve(recalculateAllDiscounts()).catch((e) => console.error('[mini-cart] przeliczanie rabatów:', e));
      }
    }
  };

  let applyingOperation = null;
  let deferredRecalculation = null;
  const calculateDiscount = (...args) => {
    const operation = calculateDiscountOperation(...args);
    applyingOperation = operation;
    const clear = () => { if (applyingOperation === operation) applyingOperation = null; };
    operation.then(clear, clear);
    return trackOperation(operation);
  };
  const recalculateAllDiscounts = (...args) => {
    // Section refreshes can arrive while a newly entered code is validating.
    // Replaying only after that operation prevents an older code list winning.
    if (applyingOperation) {
      if (!deferredRecalculation) {
        const run = () => recalculateAllDiscountsOperation(...args);
        deferredRecalculation = applyingOperation.then(run, run);
        const clear = () => { deferredRecalculation = null; };
        deferredRecalculation.then(clear, clear);
      }
      return trackOperation(deferredRecalculation);
    }
    return trackOperation(recalculateAllDiscountsOperation(...args));
  };
  const removeDiscount = (...args) => trackOperation(removeDiscountOperation(...args));
  // Zestaw rozbity (usunięto jeden z jego produktów): kod zestawu nie może zostać na drugim produkcie
  // (−189 zł na samą bransoletkę). Zestaw z karty produktu ma kod zapisany pod _bundle_uid (bundle-promo.js),
  // zestaw z kolekcji ma kod ZESTAW299 albo ZESTAW299-XXXX. Zwraca true, gdy coś zdjęto.
  const forgetBundleCodes = (bundleId) => {
    if (!bundleId) return false;
    let map = {};
    try { map = JSON.parse(localStorage.getItem('icedstuff_bundle_codes')) || {}; } catch (e) {}
    const own = map[bundleId] ? String(map[bundleId]).toUpperCase() : '';
    const id = String(bundleId).toUpperCase();
    const doomed = getAllCodes().filter((code) => {
      const c = String(code).toUpperCase();
      return own ? c === own : (c === id || c.startsWith(id + '-'));
    });
    if (!doomed.length) return false;
    doomed.forEach(removeDiscountByCode);
    if (own) {
      delete map[bundleId];
      try { localStorage.setItem('icedstuff_bundle_codes', JSON.stringify(map)); } catch (e) {}
    }
    return true;
  };

  // Po zdjęciu kodu zestawu: przelicz pozostałe kody albo wróć do cen regularnych
  const refreshAfterCodeDrop = async () => {
    if (getAllCodes().length) {
      renderDiscountPills(false);
      await recalculateAllDiscounts();
      return;
    }
    const container = $('#fcoupon-active-container');
    if (container) container.style.display = 'none';
    $$('.custom-discount-badge').forEach((el) => el.remove());
    await updateCartPrices();
  };

  // Usunięcie produktu zestawu (ilość 0 przez „Usuń” albo „−”): najpierw zdejmij kod zestawu, żeby przeliczenie
  // po odświeżeniu koszyka nie przeniosło rabatu na pozostały produkt, potem zwykła aktualizacja
  const updateQuantity = (lineKey, newQty, lineItem) => {
    const bundleId = newQty === 0 && lineItem ? lineItem.dataset.bundleId : null;
    const dropped = bundleId ? forgetBundleCodes(bundleId) : false;
    return trackOperation(updateQuantityOperation(lineKey, newQty, lineItem).then(async (result) => {
      if (dropped) await refreshAfterCodeDrop();
      return result;
    }));
  };
  window.CartDiscounts.refresh = () => getAllCodes().length ? recalculateAllDiscounts() : trackOperation(updateCartPrices());

  // Zestaw dodany z karty produktu (bundle-promo.js): nowy kod od razu w koszyku, bez kliknięcia „Zastosuj”
  window.applyCartDiscount = calculateDiscount;
  window.recalculateCartDiscounts = recalculateAllDiscounts;
  document.addEventListener('bundle:apply-discount', (event) => {
    const code = event?.detail?.code;
    if (code) calculateDiscount(code, true, true);
  });
  const runPendingQuantity = async lineKey => {
    const pending = pendingQuantityUpdates.get(lineKey);
    if (!pending) return;
    clearTimeout(qtyUpdateTimeouts.get(lineKey));
    pendingQuantityUpdates.delete(lineKey);
    qtyUpdateTimeouts.delete(lineKey);
    inFlightQtyUpdates.set(lineKey, { qty: pending.qty });
    try {
      await updateQuantity(lineKey, pending.qty, pending.lineItem);
    } finally {
      inFlightQtyUpdates.delete(lineKey);
    }
  };
  const flush = async () => {
    // Wait for writes already in flight before draining later debounced edits.
    while (pendingOperations.size || pendingQuantityUpdates.size) {
      if (pendingOperations.size) {
        const results = await Promise.allSettled(Array.from(pendingOperations));
        const failure = results.find(result => result.status === 'rejected' && !/stale/i.test(result.reason?.message || ''));
        if (failure) throw failure.reason;
      } else {
        for (const lineKey of Array.from(pendingQuantityUpdates.keys())) await runPendingQuantity(lineKey);
      }
    }
    if (getAllCodes().length) await recalculateAllDiscounts();
  };
  window.CartDiscounts.flush = flush;

  // Debounce per line-key
  const scheduleQuantityUpdate = (lineKey, newQty, lineItem) => {
    if (qtyUpdateTimeouts.has(lineKey)) {
      clearTimeout(qtyUpdateTimeouts.get(lineKey));
    }
    
    pendingQuantityUpdates.set(lineKey, { qty: newQty, lineItem });
    
    const timeout = setTimeout(() => {
      runPendingQuantity(lineKey).catch(() => {}); // updateQuantity already reports the failure.
    }, 350);
    
    qtyUpdateTimeouts.set(lineKey, timeout);
  };

  // ============================================
  // CHECKOUT Z KODAMI
  // ============================================
  
  let checkoutPending = false;
  const handleCheckout = async e => {
    e.preventDefault();
    e.stopPropagation();
    if (checkoutPending) return false;
    checkoutPending = true;
    const buttons = Array.from(document.querySelectorAll('#checkout-btn, button[name="checkout"]'));
    buttons.forEach(button => { button.disabled = true; button.setAttribute('aria-busy', 'true'); });
    try {
      await flush();
      if (!window.CartRewards || typeof window.CartRewards.settle !== 'function') throw new Error('Nie udało się sprawdzić nagród w koszyku. Spróbuj ponownie.');
      await window.CartRewards.settle();
      const response = await fetch('/cart.js', { cache: 'no-store' });
      if (!response.ok) throw new Error('Nie udało się odczytać koszyka przed płatnością');
      const currentCart = await response.json();
      if (!Array.isArray(currentCart.items)) throw new Error('Nieprawidłowa odpowiedź koszyka');
      const checkoutUrl = new URL('/checkout', window.location.origin);
      const codes = combinedCodes(currentCart);
      if (codes.length) checkoutUrl.searchParams.set('discount', codes.join(','));
      window.location.href = checkoutUrl.toString();
    } catch (err) {
      const message = 'Nie udało się przygotować koszyka do płatności. Spróbuj ponownie.';
      showToast(message, 'error');
      if (!$('#cart-toast')) {
        let error = $('#cart-checkout-error');
        if (!error) {
          error = document.createElement('p');
          error.id = 'cart-checkout-error';
          error.setAttribute('role', 'alert');
          error.style.cssText = 'position:fixed;bottom:24px;left:50%;transform:translateX(-50%);z-index:10000;padding:16px;background:#fff;color:#b91c1c;box-shadow:0 4px 24px #0002;max-width:90vw';
          document.body.appendChild(error);
        }
        error.textContent = message;
      }
      console.error('[cart-discounts] checkout:', err);
    } finally {
      checkoutPending = false;
      buttons.forEach(button => { button.disabled = false; button.removeAttribute('aria-busy'); });
    }
    return false;
  };

  // ============================================
  // EVENT LISTENERS
  // ============================================
  
  document.body.addEventListener('click', (e) => {
    if (e.target.closest('.fcoupon-pill__remove')) {
      e.preventDefault();
      const codeToRemove = e.target.closest('.fcoupon-pill__remove').dataset.code;
      if (codeToRemove) removeDiscount(codeToRemove);
      return;
    }

    if (e.target.closest('#apply-discount-btn')) {
      const input = $('#cart-discount-code');
      if (input?.value.trim()) calculateDiscount(input.value.trim());
      return;
    }

    const checkoutBtn = e.target.closest('#checkout-btn, button[name="checkout"]');
    if (checkoutBtn) {
      handleCheckout(e);
      return;
    }

    const removeBtn = e.target.closest('.new-line-item__remove');
    if (removeBtn) {
      e.preventDefault();
      const lineItem = removeBtn.closest('.new-line-item');
      const lineKey = removeBtn.dataset.lineKey;
      if (lineItem && lineKey) {
        // *** NOWE: Jeśli usuwamy gratis, animuj wyjście ***
        if (lineItem.dataset.isGift === 'true') {
          // Blokada na czas lotu — dwa szybkie kliknięcia wysyłały dwa równoległe
          // change.js, a drugie dostawało 422.
          if (removeBtn.dataset.removing === '1') return;
          removeBtn.dataset.removing = '1';

          // Klient świadomie usuwa gratis — kasujemy klucz z pamięci animacji, żeby
          // po ponownym zdobyciu progu gratis wjechał z animacją, a nie bezszelestnie.
          try { if (window.__giftAnim) window.__giftAnim.forget(lineKey); } catch (e) {}

          snapshotGifts();
          animateGiftRemoval(lineItem)
            .then(() => {
              // Po animacji wyślij request do serwera
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: lineKey, quantity: 0 })
              });
            })
            .then(async (res) => {
              const data = await res.json().catch(() => null);
              if (!res.ok) {
                throw new Error((data && (data.description || data.message)) || ('Błąd koszyka (' + res.status + ')'));
              }
              return updateCartPrices();
            })
            .catch((err) => {
              // Wiersz znika z DOM PRZED odpowiedzią serwera. Jeśli zapis się nie
              // udał, produkt nadal jest w koszyku — trzeba odbudować widok,
              // inaczej klient widzi koszyk niezgodny z rzeczywistością.
              console.error('[mini-cart] usuwanie gratisu:', err);
              showToast((err && err.message) ? err.message : 'Wystąpił błąd', 'error');
              document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: {} }));
            })
            .finally(() => { delete removeBtn.dataset.removing; });
        } else {
          updateQuantity(lineKey, 0, lineItem);
        }
      }
      return;
    }

    const qtyBtn = e.target.closest('.js-qty-btn');
    if (qtyBtn) {
      e.preventDefault();
      
      const wrapper = qtyBtn.closest('.new-quantity-selector');
      
      // Wcześniej stał tu `return`, gdy wiersz był w trakcie zapisu — klik
      // przepadał bez informacji zwrotnej. Teraz przepuszczamy go dalej:
      // scheduleQuantityUpdate scala serię, a kolejka zapisów w theme.js
      // pilnuje, żeby żądania nie nakładały się na siebie.
      
      const input = wrapper?.querySelector('.new-qty-input');
      const lineItem = qtyBtn.closest('.new-line-item');
      const lineKey = input?.dataset.lineKey;
      const action = qtyBtn.dataset.action;

      // Zestaw tylko w 1 sztuce: kod zestawu obejmuje jedną parę, druga para nie dostałaby rabatu w kasie
      if (action === 'increase' && lineItem && lineItem.dataset.bundleId) {
        showToast('Zestaw możesz kupić w jednej sztuce. Rabat obejmuje jeden zestaw na zamówienie.', 'warning');
        return;
      }

      if (input && lineKey) {
        // Punktem odniesienia jest ilość JUŻ ZAPLANOWANA do wysyłki, a nie wartość
        // z pola. Szuflada jest przerysowywana po każdej zmianie koszyka i wtedy
        // pole wraca do stanu serwera — przy szybkim klikaniu kolejne kliknięcia
        // liczyłyby od zaniżonej wartości i część inkrementacji przepadała.
        const pendingQty = pendingQuantityUpdates.get(lineKey);
        const inFlightQty = inFlightQtyUpdates.get(lineKey);
        let currentVal = pendingQty
          ? pendingQty.qty
          : (inFlightQty ? inFlightQty.qty : (parseInt(input.value, 10) || 1));
        let newVal = action === 'increase' ? currentVal + 1 : Math.max(0, currentVal - 1);
        
        input.value = newVal;
        animateEl(input, 'qty-updated');
        
        scheduleQuantityUpdate(lineKey, newVal, lineItem);
      }
    }
  });

  document.body.addEventListener('keypress', (e) => {
    if (e.target.id === 'cart-discount-code' && e.key === 'Enter') {
      e.preventDefault();
      if (e.target.value.trim()) calculateDiscount(e.target.value.trim());
    }
  });

  document.addEventListener('submit', e => {
    if (e.target?.id === 'mini-cart-form' || (e.submitter?.name === 'checkout' && e.target?.matches?.('form[action*="/cart"]'))) {
      handleCheckout(e);
    }
  });

  // ============================================
  // NOWE: Obsługa cart:refresh z animacją gratisów
  // ============================================
  
  // Przed renderem sekcji - zapamiętaj stan
  document.documentElement.addEventListener('cart:before-refresh', () => {
    snapshotGifts();
  });

  document.documentElement.addEventListener('cart:refresh', () => {
    setTimeout(() => {
      const codes = getAllCodes();
      if (codes.length > 0) { 
        renderDiscountPills(false); 
        recalculateAllDiscounts(); 
      }
      
      // *** NOWE: Porównaj gratisy i animuj zmiany ***
      const giftsAfter = getGiftVariantIds();
      
      // Nowe gratisy - animuj wejście
      giftsAfter.forEach(vid => {
        if (!giftsBefore.has(vid)) {
          const el = document.querySelector(`.is-free-gift[data-variant-id="${vid}"]`);
          if (el && !el.classList.contains('gift-animated')) {
            animateGiftEntry(el);
            el.classList.add('gift-animated');
          }
        }
      });

      // Uwaga: gratisy usunięte z DOM przez server-side render nie mogą być animowane po fakcie.
      // Dlatego kluczowe jest użycie snapshotGifts() + animateGiftRemoval() PRZED renderem.
      // Patrz: event 'cart:before-refresh' powyżej i logika w updateQuantity().
      
    }, 150);
  });

  // cart:refresh announces a render request. The drawer replaces its HTML
  // later, after coalescing requests and fetching the section. Repaint the
  // newly inserted controls so server HTML cannot erase the coupon preview.
  if (typeof MutationObserver !== 'undefined') {
    let replacementRefreshQueued = false;
    const cartControls = '#mini-cart-form, #cart-footer-total-price, [data-cart-discount-total], #mini-cart .drawer__footer';
    const observer = new MutationObserver(records => {
      if (!getAllCodes().length || replacementRefreshQueued) return;
      const replaced = records.some(record => Array.from(record.addedNodes || []).some(node =>
        node.nodeType === 1 && (node.matches?.(cartControls) || node.querySelector?.(cartControls))
      ));
      if (!replaced) return;
      renderDiscountPills(false);
      replacementRefreshQueued = true;
      Promise.resolve().then(() => {
        replacementRefreshQueued = false;
        if (getAllCodes().length) window.CartDiscounts.refresh().catch(() => {});
      });
    });
    // Watching only added cart controls excludes price text, badges and pills
    // written by this controller, preventing a refresh/repaint cycle.
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // ============================================
  // INIT
  // ============================================
  
  document.addEventListener('DOMContentLoaded', () => {
    const codes = getAllCodes();
    if (codes.length > 0) { 
      renderDiscountPills(false); 
      recalculateAllDiscounts(); 
    }
    
    // Animacja dla istniejących gratisów przy pierwszym załadowaniu
    setTimeout(() => {
      const gifts = document.querySelectorAll('.is-free-gift:not(.gift-animated)');
      gifts.forEach((gift, index) => {
        setTimeout(() => {
          animateGiftEntry(gift);
          gift.classList.add('gift-animated');
        }, 300 + index * 150);
      });
    }, 500);
  });

})();
